import React from "react";
import Space from "./Space";
import { MenuBook } from "@mui/icons-material";
import { Alert } from "@mui/material";

export const TemporaryMessage: React.FC = () => {
    const currentDate = new Date();
    const endDisplayDate = new Date(2025, 5, 6, 23, 59, 59, 999);

    if (currentDate > endDisplayDate) {
        return null;
    }

    return (
        <div>
            <Space pixels={8} direction={'v'}/>

            <Alert sx={{ marginTop: '16px' }} severity="info" icon={<MenuBook fontSize="inherit"/>}>
                  <span>
                    <strong>
                      <a
                          href="https://drive.google.com/file/d/1HYBb2Az8svEYAe0pt5Xwxx0o6Nu-A2dZ/view?usp=sharing"
                          target="_blank"
                          style={{ color: "#1976d2", textDecoration: "underline" }}
                      >
                        BAIXE AQUI:
                      </a>
                    </strong>
                    <br/>Ebook: Guia Básico para Formuladores Iniciantes na Personalização Cosmética
                  </span>
            </Alert>
        </div>
    )
}
